module.exports = __webpack_public_path__ + "static/media/mastercard.a96f8984.png";